// ---------------------------------------------------------------------------
// FAQ content - single source of truth for all Help Center pages
// ---------------------------------------------------------------------------

export const FAQ_BTN_VARIANTS = {
  FILLED: 'filled',
  FILLED_CTA: 'filled-cta',
  OUTLINE: 'outline',
  OUTLINE_INFO: 'outline-info',
}

export const FAQ_BTN_DEFAULT_CONFIG = { variant: FAQ_BTN_VARIANTS.FILLED, icon: null }

/** Button id → full spec for inline {btn:id} tokens. Single source of truth for label, variant, icon. */
export const FAQ_BUTTONS = {
  'request-approval': { label: 'Request approval', variant: FAQ_BTN_VARIANTS.FILLED, icon: 'plus' },
  'submit-request': { label: 'Submit Request', variant: FAQ_BTN_VARIANTS.FILLED, icon: 'check' },
  'save-draft': { label: 'Save Draft', variant: FAQ_BTN_VARIANTS.OUTLINE, icon: null },
  'add-attachments': { label: 'Add attachments', variant: FAQ_BTN_VARIANTS.OUTLINE, icon: 'plus' },
  'browse-file': { label: 'Browse File', variant: FAQ_BTN_VARIANTS.OUTLINE, icon: null },
  'show-approval': {
    label: 'Show Approval',
    variant: FAQ_BTN_VARIANTS.OUTLINE,
    icon: 'external-link',
  },
  'duplicate-request': {
    label: 'Duplicate request',
    variant: FAQ_BTN_VARIANTS.OUTLINE,
    icon: 'clipboard-paste',
  },
  'duplicate-and-review': {
    label: 'Duplicate & Review',
    variant: FAQ_BTN_VARIANTS.FILLED,
    icon: null,
  },
  'revoke-approval': {
    label: 'Revoke Approval',
    variant: FAQ_BTN_VARIANTS.OUTLINE_INFO,
    icon: 'ban',
  },
  confirm: { label: 'Confirm', variant: FAQ_BTN_VARIANTS.FILLED, icon: 'check-circle' },
  'confirm-approvals': {
    label: 'Confirm Approvals',
    variant: FAQ_BTN_VARIANTS.FILLED_CTA,
    icon: null,
  },
  'confirm-approval': {
    label: 'Confirm approval',
    variant: FAQ_BTN_VARIANTS.FILLED,
    icon: 'badge-check',
  },
  'contact-support': {
    label: 'Contact support',
    variant: FAQ_BTN_VARIANTS.OUTLINE,
    icon: 'help-circle',
  },
  'create-request': {
    label: 'Create Request',
    variant: FAQ_BTN_VARIANTS.FILLED,
    icon: 'arrow-right',
  },
  'didnt-find-what-youre-looking-for': {
    label: "Didn't find what you're looking for?",
    variant: FAQ_BTN_VARIANTS.OUTLINE_INFO,
    icon: 'help-circle',
  },
}

/** Optional `action` on a NOTE block. The article renderer turns it into a real control. */
export const FAQ_NOTE_ACTIONS = {
  REPLAY_WALKTHROUGH: 'replay-walkthrough',
}

export const CONTENT_BLOCK_TYPES = {
  PARAGRAPH: 'paragraph',
  SECTION: 'section',
  STEPS: 'steps',
  BULLETS: 'bullets',
  NOTE: 'note',
}

// ── Bullet display variants ────────────────────────────────────────────────
// default   - standard <ul> list (no variant field needed)
// grid      - 2-column icon-card grid (items may have icon, color, title)
// checklist - inset card with checkmark icons and optional eyebrow title
// journey   - vertical icon-row list for cycle/overview descriptions (icon + title + text)
export const BULLET_VARIANTS = {
  GRID: 'grid',
  CHECKLIST: 'checklist',
  JOURNEY: 'journey',
}

/** Route query param key for the search term (used when navigating from search to topic/article for highlight) */
export const FAQ_SEARCH_QUERY_PARAM = 'q'

/**
 * Vue Router param names for Help Center paths:
 *   /faq/:topicId           (ROUTES.FAQ_TOPIC)
 *   /faq/:topicId/:articleId (ROUTES.FAQ_ARTICLE)
 */
export const FAQ_ROUTE_PARAMS = {
  TOPIC_ID: 'topicId',
  ARTICLE_ID: 'articleId',
}

/** Fixed section IDs used by the article page scroll/TOC and the search helper */
export const FAQ_ARTICLE_SECTION_IDS = {
  OVERVIEW: 'overview',
  COMMON_QUESTIONS: 'common-questions',
}

export const INLINE_TOKEN_PATTERN = /(\*\*[^*]+\*\*|\[\[[^\]]+\]\]|\{btn:[^}]+\}|\{status:[^}]+\})/g

export const INLINE_TOKEN_TYPES = {
  TEXT: 'text',
  BOLD: 'bold',
  LINK: 'link',
  BTN: 'btn',
  STATUS: 'status',
  BREAK: 'break',
}
